"use client";

import { Sparkles } from 'lucide-react';
import { useLanguage } from "@/app/context/LanguageContext";

export default function VideoGalleryLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    const { t } = useLanguage();

    return (
        <main className="min-h-screen bg-stone-950 text-stone-100">
            <section className="relative overflow-hidden border-b border-amber-800/30">
                <div className="pointer-events-none absolute -top-32 left-1/4 h-96 w-96 rounded-full bg-amber-700/20 blur-3xl" />
                <div className="pointer-events-none absolute -bottom-20 right-1/4 h-72 w-72 rounded-full bg-orange-600/15 blur-3xl" />

                <div className="relative mx-auto max-w-6xl px-4 sm:px-6 py-12 sm:py-16 md:py-20 text-center">
                    <div className="inline-flex items-center rounded-full border border-amber-700/40 bg-amber-950/60 px-3 sm:px-4 py-1 sm:py-1.5 text-xs sm:text-sm font-medium text-amber-400 backdrop-blur-sm transition-colors gap-2">
                        <Sparkles className="h-3 sm:h-4 w-3 sm:w-4" /> {t.gallery.videoBadge}
                    </div>
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-amber-100 drop-shadow-lg mt-4 sm:mt-6">
                        {t.gallery.videoTitle.split(' ')[0]} <span className="text-amber-500">{t.gallery.videoTitle.split(' ')[1] || ''}</span>
                    </h1>
                    <div className="mx-auto my-4 sm:my-5 h-px w-20 sm:w-32 bg-gradient-to-r from-transparent via-amber-500 to-transparent" />
                    <p className="max-w-2xl mx-auto px-2 text-base sm:text-lg md:text-xl text-amber-100/70 leading-relaxed">
                        {t.gallery.videoSubtitle}
                    </p>
                </div>
            </section>
            <section className="mx-auto max-w-6xl px-4 sm:px-6 py-12">
                {children}
            </section>
        </main>
    );
}
